<div class="custom-filter-area">
    <div class="filters-area">

        <span class="title-txt">Import File</span>
        <span class="cls-btn" (click)="onCloseBtn()"><mat-icon>close</mat-icon></span>
    </div>
    <div class="import-box-area">
        <p>Please upload the Excel File.</p>
        <div class="file-load-area">
             <img style="width: 25px;margin-bottom: 10px;" src="../../../../assets/images/upload-file-icon.png">
             @if(!excelService.fileName){
            <!-- <div class="drop-zone" style="margin-bottom: 5px;" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                Drop here to upload or
            </div> -->
            <input type="file" [multiple]="false"  (change)="onFileSelected($event)" accept=".xlsx, .xls" style="display: none;"  #fileInput />
            <div class="browse-txt" (click)="fileInput.click()">Browse Files</div>
            <span style="color: #666666; font-size: 12px;">*.xlsx</span>
            }
            @else {
                <div class="file-container">
                    <div *ngIf="isLoading" class="loading-icon"></div>
                    <div *ngIf="!isLoading" class="loaded-icon"></div>
                    
                    <span class="filename">{{excelService.fileName}}
                        <br><span *ngIf="isLoading">Upoading....</span>
                        <span *ngIf="!isLoading">File Uploaded Successfully..!</span>
                    </span>
                    <span class="cls-btn" style="justify-content: flex-end;display: flex;" (click)="onRemoveFile()"><mat-icon>close</mat-icon></span>
                    
                </div>
                
                
            }
        </div>
    </div>
    <div class="right-area">
        <button class="white-red-btn" (click)="onCloseBtn()">Cancel</button>
        <button class="red-white-btn" (click)="onImportBtn($event)">Import</button>
    </div>

</div>